import Bet from '../Bet';
import _ from 'underscore';

class MultiLegBet extends Bet {

	static races() {
		return 0;
	}

	static selectors() {
		return _.map(_.range(1, this.races() + 1), function (item) {
			return {
				key: item,
				label: 'Race ' + item
			};
		});
	}

	static permutations (selections, box = false) {
		var permutations = _.first(selections).length;
		_.each(_.rest(selections, 1), function (selector) {
			permutations *= selector.length;
		});

		return permutations;
	}

	static enableBox () {
		return false;
	}

}

export default MultiLegBet;



/** WEBPACK FOOTER **
 ** ./site/sites/all/themes/custom/abr_theme/js/gambling-calculator/bets/MultiLeg/MultiLegBet.js
 **/